









































import Vue from 'vue';
import Component from 'vue-class-component';
import FormElement, { SelectOption } from 'common-modules/src/components/CommonFormElement.vue';
import JwlSubmitRow from '@/components/JwlSubmitRow.vue';
import BackBar from '@/components/BackBar.vue';
import SisBoxColumn from '@/helper/sisBoxColumn.vue';

const CommonError = () => import('common-modules/src/components/CommonError.vue');

@Component({
  components: {
    SisBoxColumn,
    BackBar,
    FormElement,
    CommonError,
    JwlSubmitRow,
  },
})
export default class SisLearningGroupEdit extends Vue {
  $refs!: {
    clcForm: HTMLFormElement;
  }

  fetching = true;
  formHasErrors = false;
  formSubmitStatus = 0;
  learningGroup = null;
  error = null;
  submitError = null;
  cities: SelectOption[] = [];
  locations: SelectOption[] = [];
  partners: SelectOption[] = [];
  saints: SelectOption[] = [];

  fetchData (): void {
    this.$store.dispatch('getData', `learning-group/edit/${this.$route.params.clc}`)
      .then((data) => {
        this.learningGroup = data;
        this.fetching = false;
      })
      .catch((e) => {
        this.error = e;
      });
  }

  submitForm (): void {
    this.formHasErrors = false;
    const { clcForm } = this.$refs;

    if (clcForm.reportValidity()) {
      const submitForm = new FormData(clcForm);
      let postUrl = 'learning-group/create';
      if (this.$route.name === 'learningGroupEdit') {
        postUrl = `learning-group/edit/${this.$route.params.clc}`;
      }
      this.formSubmitStatus = 1;
      this.$store.dispatch('postData', {
        url: postUrl,
        formData: submitForm,
      })
        .then((data) => {
          this.learningGroup = data;
          if (this.isNew) {
            this.$router.push({
              name: 'learningGroupEdit',
              params: {
                clc: data.id,
              },
            });
          }
          this.submitError = null;
          this.formSubmitStatus = 2;
          setTimeout(() => {
            this.formSubmitStatus = 0;
          }, 2000);
        })
        .catch((e) => {
          this.formSubmitStatus = -1;
          this.submitError = e;
        });
    } else {
      this.formHasErrors = true;
      this.formSubmitStatus = 3;
    }
  }

  get isNew (): boolean {
    return this.$route.name === 'learningGroupNew';
  }

  created (): void {
    if (this.$route.name === 'learningGroupEdit') {
      this.fetching = true;
      this.fetchData();
    } else {
      this.fetching = false;
    }
  }
}
